import React, { useEffect, useState } from 'react';
import { AdminLayout } from '../components/AdminLayout';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOPIC_COLORS = {
  'Work & Career Innovation':   '#1B6B72',
  'Education & Leadership':     '#0D2137',
  'Policy & Social Impact':     '#C9A84C',
  'Business & Entrepreneurship':'#2D6A4F',
  'No preference':              '#8A9BA8',
};

export default function AdminRoundTablePage() {
  const [data, setData]     = useState(null);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('op_token');
      const res = await axios.get(`${API}/admin/round-table/subscribers`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(res.data);
    } catch (e) {
      setData({ subscribers: [], total: 0, topic_counts: {} });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const filtered = (data?.subscribers || []).filter(s =>
    !search || s.email.toLowerCase().includes(search.toLowerCase()) ||
    (s.topic || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <AdminLayout>
      <div style={{ padding: '32px 40px', maxWidth: 1100 }}>
        {/* header */}
        <div style={{ marginBottom: 28 }}>
          <div style={{ fontSize: 11, fontWeight: 900, letterSpacing: '.1em', textTransform: 'uppercase', color: '#1B6B72', marginBottom: 6 }}>Round Table Podcast</div>
          <h1 style={{ margin: 0, fontSize: 26, fontWeight: 900, color: '#0D2137' }}>Launch List</h1>
          <p style={{ margin: '6px 0 0', fontSize: 14, color: '#5A6E7E' }}>Subscribers who signed up for the Fall 2026 season notification.</p>
        </div>

        {/* stat cards */}
        {data && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(160px,1fr))', gap: 14, marginBottom: 28 }}>
            <div data-testid="rt-total-card" style={{ background: '#0D2137', borderRadius: 14, padding: '18px 20px' }}>
              <div style={{ fontSize: 32, fontWeight: 900, color: '#F5F0E8', lineHeight: 1 }}>{data.total}</div>
              <div style={{ fontSize: 11, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.08em', color: 'rgba(245,240,232,.45)', marginTop: 6 }}>Total Subscribers</div>
            </div>
            {Object.entries(data.topic_counts).map(([topic, count]) => (
              <div key={topic} style={{ background: '#fff', border: '1px solid #EDE8D8', borderRadius: 14, padding: '18px 20px', borderLeft: `4px solid ${TOPIC_COLORS[topic] || '#ccc'}` }}>
                <div style={{ fontSize: 24, fontWeight: 900, color: '#0D2137', lineHeight: 1 }}>{count}</div>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#8A9BA8', marginTop: 5, lineHeight: 1.4 }}>{topic}</div>
              </div>
            ))}
          </div>
        )}

        {/* table */}
        <div style={{ background: '#fff', border: '1px solid #EDE8D8', borderRadius: 16, overflow: 'hidden' }}>
          <div style={{ padding: '16px 20px', borderBottom: '1px solid #EDE8D8', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
            <input
              placeholder="Search by email or topic…"
              value={search}
              onChange={e => setSearch(e.target.value)}
              data-testid="rt-search"
              style={{ flex: 1, maxWidth: 320, padding: '8px 14px', borderRadius: 8, border: '1px solid #DDD8CC', fontSize: 13, outline: 'none', fontFamily: 'inherit', color: '#0D2137' }}
            />
            <button onClick={load} style={{ padding: '8px 16px', borderRadius: 8, background: '#F5F0E8', border: '1px solid #DDD8CC', fontSize: 13, fontWeight: 600, cursor: 'pointer', color: '#0D2137' }}>
              Refresh
            </button>
          </div>
          {loading ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#8A9BA8', fontSize: 14 }}>Loading…</div>
          ) : filtered.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#8A9BA8', fontSize: 14 }}>No subscribers yet.</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#F9F7F4' }}>
                  {['Email', 'Topic Preference', 'Signed Up'].map(h => (
                    <th key={h} style={{ padding: '10px 20px', textAlign: 'left', fontSize: 11, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.07em', color: '#8A9BA8', borderBottom: '1px solid #EDE8D8' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map((s, i) => (
                  <tr key={s.email} style={{ borderBottom: '1px solid #F5F0E8', background: i % 2 === 0 ? '#fff' : '#FDFCFA' }}>
                    <td style={{ padding: '12px 20px', fontSize: 13, color: '#0D2137', fontWeight: 600 }}>{s.email}</td>
                    <td style={{ padding: '12px 20px' }}>
                      {s.topic ? (
                        <span style={{ display: 'inline-block', padding: '3px 10px', borderRadius: 20, background: `${TOPIC_COLORS[s.topic] || '#ccc'}18`, color: TOPIC_COLORS[s.topic] || '#555', fontSize: 12, fontWeight: 700 }}>{s.topic}</span>
                      ) : (
                        <span style={{ fontSize: 12, color: '#BBC4CC' }}>—</span>
                      )}
                    </td>
                    <td style={{ padding: '12px 20px', fontSize: 12, color: '#8A9BA8' }}>
                      {s.subscribed_at ? new Date(s.subscribed_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
